module.exports = __webpack_public_path__ + "img/google-maps.b16c0d9e.png";